import React from "react";
import codingImage from "../assets/img/code-coding-data-574071.jpg";

const About = () => {
  return (
    <div className="container-fluid py-5" id="about">
      <div className="container py-5">
        <div className="row g-5 align-items-center">
          {/* Left image column */}
          <div
            className="col-xl-5"
            data-aos="fade-right"
            data-aos-delay="100"
          >
            <div className="bg-white rounded shadow-sm overflow-hidden">
              <img
                src={codingImage}
                alt="About YOD"
                className="img-fluid w-100"
                style={{ marginBottom: "-7px" }}
              />
            </div>
          </div>

          {/* Right content column */}
          <div
            className="col-xl-7"
            data-aos="fade-left"
            data-aos-delay="300"
          >
            <h5 className="text-uppercase mb-3" style={{ color: "#FFAA00" }}>
              About YOD Business Solutions
            </h5>
            <h1 className="display-5 fw-bold mb-4" style={{ color: "#A71717" }}>
              Leading Software Solutions Provider in Ethiopia
            </h1>
            <p className="text-muted mb-4">
              Founded in 2018, YOD delivers comprehensive enterprise solutions including customizable ERP systems with multiple modules (Finance, HR, Supply Chain, Inventory, Sales), integrated School Management Systems, and professional IT project outsourcing services. Our solutions help African businesses digitize operations, improve efficiency, and meet international standards while addressing local challenges like cost optimization and transparency. With deep local market understanding and global technical expertise, we provide scalable, future-ready solutions for businesses of all sizes.
            </p>

            {/* Icons */}
            <div className="row gy-4 align-items-center mb-4">
              <div className="col-12 col-sm-6 d-flex align-items-center">
                <i className="fas fa-laptop-code fa-3x" style={{ color: "#A71717" }}></i>
                <h5 className="ms-4 mb-0 text-dark">Enterprise Software Solutions</h5>
              </div>
              <div className="col-12 col-sm-6 d-flex align-items-center">
                <i className="fas fa-cogs fa-3x" style={{ color: "#A71717" }}></i>
                <h5 className="ms-4 mb-0 text-dark">System Integration</h5>
              </div>
            </div>

            {/* Bullet points */}
            <div className="col-md-10">
              <p className="h6 mb-3 text-dark">
                <i className="fa fa-check-circle me-2" style={{ color: "#FFAA00" }}></i>
                Enterprise Resource Planning (ERP) Solutions
              </p>
              <p className="h6 mb-3 text-dark">
                <i className="fa fa-check-circle me-2" style={{ color: "#FFAA00" }}></i>
                School Management Systems
              </p>
              <p className="h6 mb-3 text-dark">
                <i className="fa fa-check-circle me-2" style={{ color: "#FFAA00" }}></i>
                IT Project Outsourcing Services
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
